export const constants = {
  STEEV_HOME_TITLE: "Steev Home",
  PAGE_NOT_FOUND: "404 Page Not Found",
  NOT_FOUND_PAGE: "Sorry, we cannot find that page.",
  GET_APP: "What are you waiting for? Get the app now.",
};
